import React, { useState } from "react";

const HighlightText = () => {
  const [highlighted, setHighlighted] = useState(false);

  // Toggle the highlighted state
  const toggleHighlight = () => setHighlighted((prev) => !prev);

  return (
    <div style={{ position: "relative" }}>
      {/* Dark overlay for the background with a soft gray tone */}
      {highlighted && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.2)", // Softer darkening for a natural feel
            zIndex: 1,
          }}
        />
      )}

      {/* Content Section */}
      <div
        style={{
          padding: "20px",
          border: "1px solid #e0e0e0", // Light gray border for a soft, natural feel
          borderRadius: "8px",
          zIndex: 2,
          position: "relative",
          backgroundColor: highlighted ? "#f1f1f1" : "white", // Soft grayish background for highlight
          boxShadow: highlighted ? "0px 8px 15px rgba(0, 0, 0, 0.1)" : "none", // Soft shadow for focus effect
          transition: "all 0.3s ease", // Smooth transition for the effect
        }}
      >
        <h2 style={{ color: highlighted ? "#4a4a4a" : "#333" }}>
          Click to Highlight this Component
        </h2>
        <p style={{ color: "#666" }}>
          This is the component that gets highlighted when you click the button
          below.
        </p>
        <button
          onClick={toggleHighlight}
          style={{
            padding: "8px 16px",
            backgroundColor: "#4CAF50", // A natural green color
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
            transition: "background-color 0.2s",
          }}
        >
          {highlighted ? "Remove Highlight" : "Highlight"}
        </button>
      </div>
      <br />
      <br />
      <ul>
        <li>Item 1</li>
        <li>Item 2</li>
        <button
          style={{
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 2,
            position: "relative",
            backgroundColor: highlighted ? "white" : "white", // Highlight the component
            boxShadow: highlighted ? "0px 0px 10px rgba(0, 0, 0, 0.5)" : "none", // Apply shadow to highlighted component
          }}
        >
          {highlighted ? "Remove Highlight" : "Highlight"}
        </button>
        <li>Item 3</li>
        <li>Item 4</li>
      </ul>

      <br />
      <br />
    </div>
  );
};

export default HighlightText;
